module.exports = __webpack_public_path__ + "img/max-file-content-signature-search.619dfd95.svg";